import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const RecurringRevenue = ({ size }) => {
  const { label, value, url, tooltip, change } = useSelector(
    (state) => state.membershipRevenue.membershipDraft.recurring?.recurringRevenueMTD
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue.membershipDraft.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <DataDisplay
        label={label}
        size={size}
        toolTipContent={tooltip}
        type="money"
        url={url}
        currency={currencySymbol}
        value={value}
        disableAnimation={isUserQa}
        changeProps={{
          changeValue: change,
          toolTip: "Percentage change from previous month",
          showBorder: true
        }}
      />
    </>
  );
};

export default RecurringRevenue;
